import { createContext, useContext } from 'react';

const defaultValue: InlineFormattedNumberContextProps = { showAllDecimals: false };
export const InlineFormattedNumberContext = createContext<InlineFormattedNumberContextProps>(defaultValue);

export interface InlineFormattedNumberContextProps {
  showAllDecimals: boolean;
  /** Overrides each InlineFormattedNumber's `align` prop for the truncated-value expansion anchor. */
  forceAlign?: 'left' | 'right' | 'center';
}

export function useInlineFormattedNumberContext() {
  return useContext(InlineFormattedNumberContext);
}
